import 'classlist-polyfill';
// import LogRocket from 'logrocket';

// LogRocket.init('apphub/logrocket-website', {
//   serverURL: 'https://logrocket-devel.appspot.com/v1/ingest',
// })

window.Raven && window.Raven.setDataCallback((data) => {
  // eslint-disable-next-line no-param-reassign
  data.extra.sessionURL = LogRocket.sessionURL;
  return data;
});

window.addEventListener('load', () => {
  //  Hamburger Menu
  const hamburger = document.querySelectorAll('.hamburger')[0];
  const dropdown = document.querySelectorAll('.mobile-dropdown')[0];
  const nav = document.querySelectorAll('nav')[0];

  hamburger.addEventListener('click', () => {
    dropdown.classList.toggle('slid-down');
    nav.classList.toggle('dropdown-open');
  }, false);
}, false);
